
import { Store, ActionTree, ActionContext } from "vuex";
import State from "./state";
import { IUserLoginInfoModel } from "src/model";

export function setProfile(store: ActionContext<State, any>, profile: IUserLoginInfoModel): void
{
    store.commit("SET_PROFILE", profile);
}

export default <ActionTree<State, any>>
{
    setProfile
};
